export enum REPORT_COLUMN_DATA_TYPE {
    DATE = "DATE",
    VARCHAR = "VARCHAR2",
    NVARCHAR = "NVARCHAR2",
    NUMBER = "NUMBER",
    CLOB = "CLOB"
  }